import React from 'react';
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import {SubscriptionNotActivePage} from "./SubscriptionNotActive";
import { withTranslation } from 'react-i18next';


class SubscriptionEndedPageClass extends SubscriptionNotActivePage {
    componentDidMount() {
        const { t } = this.props;
        document.title = `Dashbo - ${t('subscription_ended.page_title')}`;
    }

    _renderContent() {
        const { t } = this.props;
        return (<div className="row justify-content-center">
            <div className="col-md-8 text-center">
                <h1>{t('subscription_ended.title')}</h1>
                <p className="my-3">
                    {t('subscription_ended.message1')}
                </p>
                <p>
                    {t('subscription_ended.message2')}
                </p>
                <div className="col-12 text-center d-flex justify-content-center my-4">
                    <Link to="/agency/subscription" className="btn -alt" style={{textDecoration: 'none'}}>
                        {t('subscription_ended.activate_plan')}
                    </Link>
                </div>
                {/*<div className="col-12 text-center d-flex justify-content-center mb-4">*/}
                {/*    <Button className="-alt -negative" id="btnAgendarDemo">Agendar una demo</Button>*/}
                {/*</div>*/}
                {/*<div className="col-12 text-center d-flex justify-content-center mb-4">*/}
                {/*    <Button className="-alt -negative" id="btnExtenderFreeTrial">Extender el período de prueba</Button>*/}
                {/*</div>*/}
                <div className="mt-4">
                    <p>
                        {t('subscription_ended.contact_message')}
                    </p>
                </div>
            </div>
        </div>)
    }
}

export const SubscriptionEndedPage = withTranslation()(SubscriptionEndedPageClass);
